import useContextWithErrorHandler from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { EditTeachingOrderContext } from '../providers/EditTeachingOrderProvider';
import { UseTeachingOrder } from '../providers/EditTeachingOrderProvider/types';

const useTeachingOrder = (): UseTeachingOrder => {
  const [state, dispatch] = useContextWithErrorHandler<UseTeachingOrder>(
    EditTeachingOrderContext,
    'EditTeachingOrderProvider'
  );

  return [state, dispatch];
};

export default useTeachingOrder;
